import axios from "axios";
import safeStorage from "@/lib/safeStorage";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API, withCredentials: false });

api.interceptors.request.use((config) => {
  const token = safeStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const rid = safeStorage.getItem("restaurant_id");
  if (rid) config.headers["X-Restaurant"] = rid;
  return config;
});

// Normalise FastAPI validation errors (422): `detail` can be an array of
// `{type, loc, msg, input, ctx, url}` objects. Coerce to a readable string so
// UI code can safely render `err.response.data.detail` in toasts/JSX.
function coerceDetail(d) {
  if (d == null) return d;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && e.msg) || (typeof e === "string" ? e : JSON.stringify(e))).join(" · ");
  if (typeof d === "object") return d.msg || JSON.stringify(d);
  return String(d);
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.data && "detail" in err.response.data) {
      err.response.data.detail = coerceDetail(err.response.data.detail);
    }
    return Promise.reject(err);
  }
);

export default api;
